import { render } from "./StudyView.vue?vue&type=template&id=68712069&scoped=true"
import script from "./StudyView.vue?vue&type=script&lang=js"
export * from "./StudyView.vue?vue&type=script&lang=js"

import "./StudyView.vue?vue&type=style&index=0&id=68712069&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68712069"]])

export default __exports__